import { t } from '@frontend/utils/I18n'

export type StartCallingPermissions = {
  canStartCallingSession?: boolean
  demoSite?: boolean
}

export function startDisabledReason(permissions?: StartCallingPermissions): string | undefined {
  if (permissions?.demoSite) return t('shared.demo_site.calls_disabled')
  if (permissions?.canStartCallingSession === false) {
    return t('components.impact_dashboard.current_cycle.start_disabled_not_yours')
  }

  return undefined
}
